export default __webpack_public_path__ + "static/media/fundadoras.17b20a71.png";